import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import Media from './media-model'
import {
  CreateMediaAsync,
  DeleteMediaAsync,
  LoadMediasAsync,
} from './media-thunk'
const initialState: mediaSliceState = {
  media: [],
  selected_media: '',
  is_loading_media: false,
  is_creating_media: false,
  is_deleting_media: false,
}
export interface mediaSliceState {
  media: Media[]
  selected_media?: string
  is_loading_media: boolean
  is_creating_media: boolean
  is_deleting_media: boolean
}
export const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setSelectedmedia: (state, action) => {
      state.selected_media = action.payload
    },
    clearStatemedia: (state) => {
      state.media = []
      state.is_loading_media = false
      state.is_creating_media = false
      state.is_deleting_media = false
    },
    mergemedia: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_media = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.media = merge(state.media, payload) as any
        }
      }
    },

    add_media: (state, action) => {
      if (action.payload) {
        state.media = [...state.media, action.payload]
      }
    },
    set_media: (state, action) => {
      let { key, value, id } = action.payload
      state.media = state.media.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediasAsync.pending, (state) => {
      state.is_loading_media = true
    })
    builder.addCase(LoadMediasAsync.fulfilled, (state, action) => {
      state.is_loading_media = false
      if (action.payload) {
        state.media = action.payload
      }
    })
    builder.addCase(LoadMediasAsync.rejected, (state) => {
      state.is_loading_media = false
    })
    builder.addCase(CreateMediaAsync.pending, (state) => {
      state.is_creating_media = true
    })
    builder.addCase(CreateMediaAsync.fulfilled, (state) => {
      state.is_creating_media = false
    })
    builder.addCase(CreateMediaAsync.rejected, (state) => {
      state.is_creating_media = false
    })
    builder.addCase(DeleteMediaAsync.pending, (state) => {
      state.is_deleting_media = true
    })
    builder.addCase(DeleteMediaAsync.fulfilled, (state, action) => {
      state.is_deleting_media = false
      if (state.media) {
        state.media = state.media.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteMediaAsync.rejected, (state) => {
      state.is_deleting_media = false
    })

    builder.addCase(autoThunks.update_media.pending, (state) => {
      state.is_loading_media = true
    })
    builder.addCase(autoThunks.update_media.fulfilled, (state, action) => {
      state.is_loading_media = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.update_media.rejected, (state) => {
      state.is_loading_media = false
    })

    builder.addCase(autoThunks.get_all_media_data.pending, (state) => {
      state.is_loading_media = true
    })
    builder.addCase(
      autoThunks.get_all_media_data.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_all_media_data.rejected, (state) => {
      state.is_loading_media = false
    })

    builder.addCase(autoThunks.get_media_for_customer.pending, (state) => {
      state.is_loading_media = true
    })
    builder.addCase(
      autoThunks.get_media_for_customer.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_media_for_customer.rejected, (state) => {
      state.is_loading_media = false
    })

    builder.addCase(
      autoThunks.fetch_media_for_approval_evaluation.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.fetch_media_for_approval_evaluation.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.fetch_media_for_approval_evaluation.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(
      autoThunks.fetch_medias_for_approval_evaluation.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.fetch_medias_for_approval_evaluation.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.fetch_medias_for_approval_evaluation.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(autoThunks.load_content_house_medias.pending, (state) => {
      state.is_loading_media = true
    })
    builder.addCase(
      autoThunks.load_content_house_medias.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_content_house_medias.rejected, (state) => {
      state.is_loading_media = false
    })

    builder.addCase(
      autoThunks.addNewMediaContentToContentHouse.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.addNewMediaContentToContentHouse.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.addNewMediaContentToContentHouse.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(
      autoThunks.updateMediaContentToContentHouse.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.updateMediaContentToContentHouse.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.updateMediaContentToContentHouse.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(
      autoThunks.requestMediaContentApprovalForContentHouse.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.requestMediaContentApprovalForContentHouse.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.requestMediaContentApprovalForContentHouse.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(
      autoThunks.cancelMediaContentApprovalForContentHouse.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.cancelMediaContentApprovalForContentHouse.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.cancelMediaContentApprovalForContentHouse.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(
      autoThunks.delete_media_from_content_house.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.delete_media_from_content_house.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.delete_media_from_content_house.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(
      autoThunks.get_content_house_medias_for_season_configurations.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.get_content_house_medias_for_season_configurations.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_content_house_medias_for_season_configurations.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(autoThunks.load_media.pending, (state) => {
      state.is_loading_media = true
    })
    builder.addCase(autoThunks.load_media.fulfilled, (state, action) => {
      state.is_loading_media = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.load_media.rejected, (state) => {
      state.is_loading_media = false
    })

    builder.addCase(
      autoThunks.get_media_for_curated_media_list.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.get_media_for_curated_media_list.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_media_for_curated_media_list.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(
      autoThunks.get_media_connected_to_processed.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.get_media_connected_to_processed.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_media_connected_to_processed.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )

    builder.addCase(
      autoThunks.get_media_for_system_schedules.pending,
      (state) => {
        state.is_loading_media = true
      },
    )
    builder.addCase(
      autoThunks.get_media_for_system_schedules.fulfilled,
      (state, action) => {
        state.is_loading_media = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_media_for_system_schedules.rejected,
      (state) => {
        state.is_loading_media = false
      },
    )
  },
})

function handleResult(action: any, state: mediaSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_media = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.media = merge(state.media, payload) as any
    }
  }
}

export const {
  clearStatemedia,
  setSelectedmedia,
  set_media,
  mergemedia,
  add_media,
} = mediaSlice.actions

export const get_media =
  (id?: string) =>
  (state: {
    media: {
      media: Media[]
    }
  }): Media | null => {
    let temp = state?.media?.media?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.media?.media[0] || null
  }
export const get_selected_media = (state: {
  media: mediaSliceState
}): Media | null => {
  let id = state?.media?.selected_media
  let temp = state?.media?.media?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_media = (state: {
  media: {
    media: Media[]
  }
}): Media[] => {
  let temp = state?.media?.media
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_media_busy = (state: { media: mediaSliceState }) => {
  return (
    state?.media.is_deleting_media ||
    state?.media.is_loading_media ||
    state?.media.is_creating_media
  )
}
export const is_deleting_media_busy = (state: { media: mediaSliceState }) => {
  return state?.media.is_deleting_media
}
export const is_loading_media_busy = (state: { media: mediaSliceState }) => {
  return state?.media.is_loading_media
}
export const is_creating_media_busy = (state: { media: mediaSliceState }) => {
  return state?.media.is_creating_media
}

export default mediaSlice.reducer
